/**
 * Emojis Tab Content - Search results or category grid
 * Uses deferred rendering for snappy tab switching
 */

import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { CATEGORY_NAMES, getEmojisByCategory } from '../data';
import EmojiSection from './EmojiSection';

const EmojisTabContent = ({
  searchResults,
  recentEmojis,
  currentValue,
  categoryRefs,
  onSelect,
}) => {
  const [isReady, setIsReady] = useState(false);

  // Defer heavy rendering to next frame for snappy tab switch
  useEffect(() => {
    setIsReady(false);
    const id = requestAnimationFrame(() => {
      setIsReady(true);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  // Show loading state briefly
  if (!isReady) {
    return (
      <div className="ip-loading">
        <FontAwesomeIcon icon={faSpinner} spin />
      </div>
    );
  }

  // Search mode
  if (searchResults) {
    return (
      <div className="ip-section">
        <div className="ip-section__header">{searchResults.length} results</div>
        {searchResults.length === 0 ? (
          <div className="ip-empty">No results found</div>
        ) : (
          <div className="ip-section__grid">
            {searchResults.map((item, i) => (
              <button
                key={i}
                className={`ip-btn ${currentValue === item.emoji ? 'ip-btn--selected' : ''}`}
                onClick={() => onSelect({ type: 'emoji', value: item.emoji })}
              >
                {item.emoji}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // Browse mode
  return (
    <>
      {/* Recent emojis */}
      {recentEmojis.length > 0 && (
        <div className="ip-section" ref={el => categoryRefs.current['Recent'] = el}>
          <div className="ip-section__header">Recent</div>
          <div className="ip-section__grid">
            {recentEmojis.map((emoji, i) => (
              <button
                key={i}
                className={`ip-btn ${currentValue === emoji ? 'ip-btn--selected' : ''}`}
                onClick={() => onSelect({ type: 'emoji', value: emoji })}
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      )}
      
      {/* Category sections */}
      {CATEGORY_NAMES.map(cat => (
        <div key={cat} ref={el => categoryRefs.current[cat] = el}>
          <EmojiSection
            category={cat}
            emojis={getEmojisByCategory(cat)}
            onSelect={onSelect}
            currentValue={currentValue}
          />
        </div>
      ))}
    </>
  );
};

export default EmojisTabContent;
